<div [cdkTrapFocusAutoCapture]="true" cdkTrapFocus>
	<modal-header-default
		[options]="{
			headerTitleKey: null,
			headerTitle: ('payment_processing' | translate)
		}"
		class="border"></modal-header-default>
	<div class="wrapper">
		<svg-inline class="screen-img" src="/assets/images/deposit/error.svg" />
		<div class="section-title"> {{ "checkout_deposit_payment_failed_explanation" | translate }}</div>
		<div class="info"> {{ "email_mismatch_info" | translate }}</div>
		<button
			class="btn btn-lg btn-link btn-bold btn-bigger-text button-change-payment font-bold"
			(click)="goToPaymentMethodSelection()"
			>{{ "checkout_link_change_payment" | translate }}
		</button>
		<button
			class="btn btn-lg btn-primary font-bold btn-try-again"
			(click)="tryAgain()"
			[disabled]="tryAgainButtonDisabled"
			>{{ "try_again" | translate }}</button
		>
	</div>
</div>
